var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/_Symbol.js
// module id = 18
// module chunks = 36434998819415 79611799117203 120690779865315 125193764933041 152099450743416